import { apiService } from '../../../shared/services/apiService';
import {
  CustomerInbodyAccount,
  InbodyAccountInfo,
} from '../../interfaces/customerInbodyAccount';
import {
  CustomerInbodyAccountService,
  GetCustomerInbodyAccountsResponse,
} from './customerInbodyAccountService';

export const scanIqCustomerInbodyAccountService: CustomerInbodyAccountService = {
  async getCustomerInbodyAccounts(customerId: number, entityId?: number) {
    const resp = await apiService.get<GetCustomerInbodyAccountsResponse>(
      `/api/scan-iq/customers/${customerId}/inbody-accounts`,
      { params: { entityId } },
    );

    return resp.data;
  },

  async refreshCustomerInbodyAccount(
    customerId: number,
    inbodyAccountInfo: InbodyAccountInfo,
    entityId?: number,
  ) {
    const resp = await apiService.post<CustomerInbodyAccount>(
      `/api/scan-iq/customers/${customerId}/inbody-accounts`,
      inbodyAccountInfo,
      { params: { entityId } },
    );

    return resp.data;
  },

  async requestInbodyAccountAccess(
    customerId: number,
    inbodyAccountInfo: InbodyAccountInfo,
    entityId?: number,
  ) {
    const resp = await apiService.post<CustomerInbodyAccount>(
      `/api/scan-iq/customers/${customerId}/inbody-accounts/request-access`,
      inbodyAccountInfo,
      { params: { entityId } },
    );

    return resp.data;
  },
};
